export function initAccordion() {
    jQuery('.accordion-item.is-expanded .accordion-content').slideToggle('slow');
    jQuery('.accordion-item .accordion-header').click(function() {
        const parent = jQuery(this).parent();
        if (parent.hasClass('is-expanded')) {
            parent.removeClass('is-expanded');
            parent.find('.accordion-content').slideUp();
        } else {
            parent.addClass('is-expanded');
            parent.find('.accordion-content').slideToggle('slow');
        }
    });

    initBlockText();
}

function initBlockText() {
    jQuery('.products-block .block-text-toggle').on('click', function() {
        const $btn = jQuery(this);
        const $wrap = $btn.closest('.block-text');
        const expanded = !$wrap.hasClass('is-expanded');

        $wrap.toggleClass('is-expanded', expanded);
        $btn.attr('aria-expanded', expanded);
    });
}